<template>
  <v-container>
    <v-row
      align="center"
      justify="start"
      no-gutters
      class="my-2"
      v-if="getIsAdmin"
    >
      <v-btn color="accent" outlined @click="createNewCustomer">
        <v-icon small left>add</v-icon>Nouveau client
      </v-btn>
    </v-row>
    <v-card>
      <v-card-text>
        <CustomerGrid></CustomerGrid>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { CustomerGrid } from "../components";
import { mapGetters } from "vuex";
export default {
  name: "CustomerIndex",
  components: {
    CustomerGrid
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  computed: { ...mapGetters(["getCustomers", "getIsAdmin"]) },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.$store.dispatch("loadCustomers");
      } finally {
        this.loading = false;
      }
    },
    createNewCustomer() {
      this.$router.push({ name: "CustomerEditor" });
    }
  }
};
</script>

<style></style>
